module.exports = __webpack_public_path__ + "static/img/banner7.7854939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/banner7.jpg
// module id = 4wRS
// module chunks = 0